import { VariableType } from 'json-to-graphql-query';

import { RoleObjectType } from '@/interfaces/roleObjectType';
import { EntityResource } from './entity.resource';

/**
 * Resource ról
 *
 * @export
 * @class RoleResource
 * @extends {EntityResource<RoleObjectType>}
 */
export class RoleResource extends EntityResource<RoleObjectType> {
  protected getFields = {
    id: true,
    name: true
  };

  protected listFields = {
    id: true,
    name: true,
    parent: {
      id: true,
      name: true
    }
  };

  protected listVariables = { filters: 'RoleFilters' };
  protected listQueryName = 'roles';
  protected entityQueryName = 'role';

  constructor() {
    super({ entityName: 'role' });
  }

  /**
   * Dodaje rolę do użytkownika
   *
   * @param {number} roleId
   * @param {number} profileId
   * @returns {Promise<number>}
   * @memberof RoleResource
   */
  public async userRoleAdd(roleId: number, profileId: number): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { roleId: 'Int!', profileId: 'Int!' },
        userRoleAdd: {
          __args: { roleId: new VariableType('roleId'), profileId: new VariableType('profileId') }
        }
      }
    });
    return this.mutation(
      {
        mutation,
        variables: { roleId, profileId }
      },
      'userRoleAdd'
    );
  }

  /**
   * Usuwa rolę użytkownika
   *
   * @param {number} roleId
   * @param {number} profileId
   * @returns {Promise<number>}
   * @memberof RoleResource
   */
  public async userRoleDelete(roleId: number, profileId: number): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { roleId: 'Int!', profileId: 'Int!' },
        userRoleDelete: {
          __args: { roleId: new VariableType('roleId'), profileId: new VariableType('profileId') }
        }
      }
    });
    return this.mutation(
      {
        mutation,
        variables: { roleId, profileId }
      },
      'userRoleDelete'
    );
  }

  /**
   * Pobiera listę ról użytkownika
   *
   * @param {number} profileId
   * @returns {Promise<RoleObjectType[]>}
   * @memberof RoleResource
   */
  public async userRoles(profileId: number): Promise<RoleObjectType[]> {
    const query = this.prepareOptions({
      query: {
        __variables: { profileId: 'Int!' },
        userRoles: {
          __args: { profileId: new VariableType('profileId') },
          id: true
        }
      }
    });
    return this.query(
      {
        query,
        variables: { profileId }
      },
      'userRoles'
    );
  }
}

export const roleResource = new RoleResource();
